import React from 'react'
import { ContentBlock } from '@/blocks/Content/Component'
import { CallToActionBlock } from '@/blocks/CallToAction/Component'
import { FormBlock } from '@/blocks/Form/Component'
import { RoundedGraphicBlock } from '@/blocks/RoundedGraphic/Component'
import { CoachCTABlock } from '@/blocks/CoachCTA/Component'
import { SpacerBlock } from '@/blocks/Spacer/Component'
import { CallToActionStripBlock } from '@/blocks/StripCTA/Component'
import { SectionBlock } from '@/blocks/Section/Component'
import { HtmlBlock } from '@/blocks/HTML/Component'
import { BoxBlock } from '@/blocks/Box/Component'
import { RichTextBlock } from '@/blocks/RichTextBlock/Component'
import { ContainerBlock } from '@/blocks/Container/Component'
import { BuyTicketsBlock } from '@/blocks/BuyTickets/Component'
import { GridBlock } from '@/blocks/Grid/Component'
import { GridCellBlock } from '@/blocks/GridCell/Component'
import Details from '@/blocks/Details/Component'
import { MediaBlock } from '@/blocks/Media/Component'
import CoachListBlock from '@/blocks/CoachList/Component'
import { CoachMapBlock } from '@/blocks/CoachMap/Component'
import { LottieBlock } from '@/blocks/Lottie/Component'
import { LightGalleryBlock } from '@/blocks/PhotoGallery'
import { NewsTickerBlock } from '@/blocks/NewsTicker/Component'

export const RenderBlocks: React.FC<{
  blocks: { id?: string | null; blockType: string; blockName?: string | null }[]
}> = (props) => {
  const { blocks } = props
  const hasBlocks = blocks && Array.isArray(blocks) && blocks.length > 0
  const blockComponents = {
    content: ContentBlock,
    cta: CallToActionBlock,
    formBlock: FormBlock,
    mediaBlock: MediaBlock,
    roundedGraphic: RoundedGraphicBlock,
    coachCta: CoachCTABlock,
    spacer: SpacerBlock,
    ctaStrip: CallToActionStripBlock,
    section: SectionBlock,
    html: HtmlBlock,
    box: BoxBlock,
    richText: RichTextBlock,
    container: ContainerBlock,
    buyTickets: BuyTicketsBlock,
    grid: GridBlock,
    gridCell: GridCellBlock,
    details: Details,
    coachList: CoachListBlock,
    coachMap: CoachMapBlock,
    lottie: LottieBlock,
    photoGalleryBlock: LightGalleryBlock,
    newsTicker: NewsTickerBlock,
  }

  if (hasBlocks) {
    return (
      <>
        {blocks.map((block, index) => {
          const { blockType } = block

          if (blockType && blockType in blockComponents) {
            const Block = blockComponents[blockType]

            if (Block) {
              return <Block key={index} {...block} />
            }
          }
          return null
        })}
      </>
    )
  }

  return null
}
